<template>
  <div>
    <mdb-row>
    <mdb-col md="2" class="v-list">
      <vertical-list :titles="routes.titles" :active="current" @select-item="onSelectItem"/>
    </mdb-col>
    <mdb-col md="10">
      <router-view></router-view>
    </mdb-col>
    </mdb-row>
  </div>
</template>
<script>
import {} from 'mdbvue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import VerticalList from '../../../components/common/VerticalList.vue'
export default {
  name: 'StudentIntroPage',
  components: { VerticalList },
  props: [],
  data: () => ({
    TAG: 'StudentIntroPage >>',
    routes: {
      titles: ['훈련개요', '교과편성 총괄표', '교과별 계획'],
      comps: ['TrainingIntro', 'TrainingStructure', 'TrainingPlan']
    },
    training: {}
  }),
  computed: {
    current () {
      const name = this.$route.name
      const ix = this.routes.comps.findIndex(c => c === name)
      return ix === -1 ? 0 : ix
    }
  },
  methods: {
    onSelectItem (index) {
      const name = this.routes.comps[index]
      this.$router.push({ name, query: this.$route.query })
    }
  }
}
</script>
